import { AuthService } from '@/services/auth.service.js';

export default {
  namespaced: true,
  state: {
    currentUser: {},
    authError: false
  },
  mutations: {
    SET_CURRENT_USER (state, payload) {
      state.currentUser = payload;
    },
    RESET_STATE (state) {
      state.currentUser = {};
    },
    SET_AUTH_ERROR (state, payload) {
      state.authError = payload
    }
  },
  getters: {
    isSuperAdmin (state) {
      return state.currentUser?.roletype === 'SUPER ADMIN'
    },
    isManager (state) {
      return state.currentUser?.roletype === 'MANAGER'
    },
    userRole (state) {
      return state.currentUser?.roletype
    },
    hasRole: state => roles => roles.includes(state.currentUser?.roletype)
  },
  actions: {
    async getUser ({ commit }) {
      try {
        const { data } = await AuthService.getCurrent();
        commit('SET_CURRENT_USER', data);
      } catch (e) {
        console.error(e);
        throw e;
      }
    },
    resetState ({ commit }) {
      commit('RESET_STATE');
    },
  },
};
